// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IpTj","input":"styles_input__uBKEf"};